import React from "react";
import defaultUser from '../../../../assets/img/nophoto.png'
import "./SideDrawer.css";
import classnames from "classnames";
import {ADD_PROPERTIES, ADMIN, AGENTS, CHAT, PROPERTIES} from "../../../../actions/types";
import {Link} from "react-router-dom";
import NotificationItem from "../Notification/NotificationItem";
import DataNotFound from "../../DataNotFound";
import userLogo from "../../../../assets/img/nophoto.png";
import {connect} from "react-redux";
import {logout} from "../../../../actions/auth";

const SideDrawer = ({auth: {isAuthenticated, user}, logout, show}) => {
    let drawerClasses = "side-drawer";
    if (show) {
        drawerClasses = "side-drawer open";
    }

    return (
        <nav className={drawerClasses}>
            <ul>
                <li className="user-avatar text-danger side-user-avatar">
                    <a href="/"><img src={user.avatar ? user.avatar : userLogo} alt="user" className="rounded-circle"
                                     style={{width: '100px'}}/></a>
                    <a href="">{user.name}</a>
                </li>
                <li>
                    <Link to="/agent-listing">Agents</Link>
                </li>
                <li>
                    <Link to="/properties">Properties</Link>
                </li>
                <li>
                    <Link to="/private-chat">Chat</Link>
                </li>
                {
                    ((user && user.role) && user.role.name === "Admin") &&
                    <li>
                        <Link to="/add-property">Add Property</Link>
                    </li>
                }
                <li>
                    <Link to="/user-profile">Profile</Link>
                </li>
                <li>
                    <Link to="/invite">Invite</Link>
                </li>
                <li>
                    <Link to="/private-properties">My Properties</Link>
                </li>
                <li>
                    <Link to="/change-password">Change Password</Link>
                </li>
                {/* <li className={"notification-section"}>

                    <div className="dropdown">
                        <Link to={''} className="dropdown-toggle" type="button" id="dropdownMenuButton"
                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="fa fa-bell"/>
                        </Link>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <div className="header text-center h6">
                                Notification
                            </div>


                            {(user && user.notification &&user.notification.length>0) ? user.notification.map((data, index) =>
                                    <NotificationItem
                                        key={index}
                                        title={data.notification ? data.notification.title : ''}
                                        userProfile={data.user_avatar ? data.user_avatar : ''}
                                        notificationId={data._id}
                                        user_name={data.user_name}
                                        user_avtart={data.user_avatar}
                                        time={data.notification ? data.notification.createdAt : ''}
                                        action={data.notification ? data.notification.action : ''}
                                        name={data.notification && data.notification.title ? data.notification.title : ''}
                                        user_id={data.notification && data.notification.user ? data.notification.user : 0}
                                    />):
                                <div className="dropdown-item">
                                    <DataNotFound message={"not ound"}/>
                                </div>}

                        </div>
                    </div>
                </li>*/}
                <li>
                    <Link to={'/login'} onClick={() => {
                        localStorage.removeItem('vip_token');
                        // window.location.href='/login';
                        logout()
                    }}>Logout</Link>
                </li>
            </ul>
        </nav>
    );
};
const mapStateToProps = (state) => ({
    auth: state.auth,
    user: state.auth.user,
});

export default connect(mapStateToProps, {logout})(SideDrawer);
